export class MessageBuilder {
  constructor(entityName, processName, postfix) {
    this.entityName = entityName;
    this.processName = processName;
    this.lastCharOfProcessNameIsE =
      processName.charAt(processName.length - 1) === 'e';
    this.postfix = postfix ? ` ${postfix}` : '';
  }

  success() {
    return `${this.entityName} ${this.processName}${this.lastCharOfProcessNameIsE ? 'd' : 'ed'}${this.postfix}`;
  }

  completed() {
    return `${this.entityName} ${this.processName}${this.postfix} competed`;
  }

  completedWithErrors() {
    return `${this.entityName} ${this.processName}${this.postfix} competed with errors`;
  }

  failed() {
    return `Unable to ${this.processName} ${this.entityName}${this.postfix}`;
  }

  processing(progress) {
    return progress != null
      ? `${this.entityName} ${this.lastCharOfProcessNameIsE ? this.processName.substring(0, this.processName.length - 1) : this.processName}ing${this.postfix} ... ${progress}%`
      : `${this.entityName} are being prepared`;
  }

  queue(progress) {
    return `${this.entityName} are being prepared ... ${progress}%`;
  }
}

export class ActionMessageBuilder {
  constructor(entityName) {
    this.entityName = entityName;
  }

  action(processName, postfix) {
    return new MessageBuilder(this.entityName, processName, postfix);
  }

  add() {
    return this.action('add');
  }

  saveAsDraft() {
    return this.action('save', 'as draft');
  }

  update() {
    return this.action('update');
  }

  delete() {
    return this.action('delete');
  }

  addTo(postfix) {
    return this.action('add', `to ${postfix}`);
  }

  moveTo(postfix) {
    return this.action('move', `to ${postfix}`);
  }

  sendTo(postfix) {
    return this.action('send', `to ${postfix}`);
  }

  copyToClipboard(text) {
    return `${text} copied to your clipboard`;
  }

  markAsRead() {
    return this.action('mark', 'as read');
  }

  download() {
    return this.action('download');
  }

  upload() {
    return this.action('upload');
  }

  export() {
    return this.action('export');
  }

  import() {
    return this.action('import');
  }
}
